<template>
    <div
        class="modal fade"
        id="modalCancelAllService"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalCancelAllServiceLabel"
        aria-hidden="true"
        ref="modal"
    >
        <div class="modal-dialog modal-dialog-centered cancel-service-dialog" role="document">
            <div class="modal-content cancel-service-modal">
                <div class="modal-body text-center">
                    <div class="warning-icon-wrapper">
                        <span class="warning-icon">!</span>
                    </div>
                    <h5 class="modal-title" id="modalCancelAllServiceLabel">Batalkan Servis?</h5>
                    <p class="modal-description">
                        Status pengajuan ini akan diubah menjadi Dibatalkan. Seluruh data tetap disimpan dan dapat dilihat pada halaman detail servis.
                    </p>

                    <div class="warning-box">
                        Seluruh data ini akan tetap ada di riwayat namun tidak dapat diproses lagi.
                    </div>

                    <div class="reason-field text-left">
                        <label class="reason-label" for="cancelReason">Alasan Pembatalan</label>
                        <textarea
                            id="cancelReason"
                            class="form-control reason-textarea"
                            :class="{ 'is-invalid': errorMessage }"
                            rows="4"
                            placeholder="Tuliskan alasan pembatalan..."
                            v-model="reason"
                            :disabled="loading"
                            @input="errorMessage = ''"
                        ></textarea>
                        <small v-if="errorMessage" class="reason-error">{{ errorMessage }}</small>
                    </div>
                </div>

                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-primary btn-kembali" :disabled="loading" @click="closeModal">
                        Kembali
                    </button>
                    <button type="button" class="btn btn-outline-danger btn-batalkan" :disabled="loading" @click="submit">
                        {{ loading ? 'Membatalkan...' : 'Batalkan Servis' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalCancelAllService',
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            reason: '',
            errorMessage: '',
        };
    },
    methods: {
        showModal() {
            this.reason = '';
            this.errorMessage = '';
            $(this.$refs.modal).modal('show');
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');
        },
        submit() {
            if (this.loading) return;
            if (!this.reason.trim()) {
                this.errorMessage = 'Mohon untuk memberikan penjelasan yang lebih mendetail.';
                return;
            }
            this.$emit('simpan', this.reason.trim());
        },
    },
    beforeDestroy() {
        $(this.$refs.modal).modal('hide');
    },
};
</script>

<style scoped>
.cancel-service-dialog {
    max-width: 460px;
}

.cancel-service-modal {
    border-radius: 16px;
    border: none;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.modal-body {
    padding: 2rem 1.75rem 0.5rem;
}

.warning-icon-wrapper {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #fdecea;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
}

.warning-icon {
    color: #dc3545;
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
}

.modal-title {
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    margin-bottom: 10px;
}

.modal-description {
    font-size: 14px;
    color: #495057;
    line-height: 1.5;
    margin-bottom: 16px;
}

.warning-box {
    background: #fdecea;
    border: 1px solid #f6c6c8;
    border-radius: 8px;
    color: #dc3545;
    font-size: 13px;
    line-height: 1.5;
    padding: 12px 16px;
    margin-bottom: 20px;
    text-align: center;
}

.reason-field {
    margin-bottom: 4px;
}

.reason-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 8px;
}

.reason-textarea {
    font-size: 14px;
    border-radius: 6px;
    border: 1px solid #ced4da;
    resize: vertical;
}

.reason-textarea:focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.reason-textarea.is-invalid {
    border-color: #dc3545;
}

.reason-textarea.is-invalid:focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
}

.reason-error {
    display: block;
    color: #dc3545;
    font-size: 12px;
    margin-top: 6px;
}

.modal-footer {
    padding: 1rem 1.75rem 1.75rem;
    display: flex;
    justify-content: space-between;
    gap: 8px;
}

.btn-kembali {
    font-size: 13px;
    padding: 8px 24px;
}

.btn-batalkan {
    font-size: 13px;
    padding: 8px 20px;
    border-color: #dc3545;
    color: #dc3545;
}

.btn-batalkan:hover {
    background-color: #fdecea;
}
</style>



// WEBPACK FOOTER //
// src/components/Service/CustomComponent/ModalCancelAllService.vue